export const cloneDeep = (data : any) => JSON.parse(JSON.stringify(data));
